import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from '../../Shared/NavBar/NavBar';
import Footer from '../../Shared/Footer/Footer';
import ScrollToTop from '../../common/ScrollToTop';

const Main = () => {
    return (
        <div>
            <NavBar></NavBar>
            <ScrollToTop/>
            <Outlet></Outlet>
            <Footer></Footer>
        </div>
    );
};

export default Main;